import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import {
  DataTable,
  DataTableFilterMeta,
  DataTableFilterMetaData,
} from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { DatasetInfo } from "../../serviceapi/dataCollectorApi";
interface AllDatasetsListProps {
  datasetsList: DatasetInfo[];
  selectedDatasets: DatasetInfo[];
  fetchDatasetsInfoRecent: (selectedDatasets: DatasetInfo[]) => void;
  setSelectedDatasets: (selectedDatasets: DatasetInfo[]) => void;
}

const AllDatasetsList = ({
  datasetsList,
  selectedDatasets,
  fetchDatasetsInfoRecent,
  setSelectedDatasets,
}: AllDatasetsListProps) => {
  const [showReader, setShowReader] = useState<boolean>(true);
  const [showMeter, setShowMeter] = useState<boolean>(false);
  const [filters, setFilters] = useState<DataTableFilterMeta>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
  });
  const handleDatasetsSelection = (e: { value: DatasetInfo[] }) => {
    fetchDatasetsInfoRecent(e.value);
    setSelectedDatasets(e.value);
  };

  const updateTitle = (data: Array<DatasetInfo>) => {
    let tempData: Array<DatasetInfo> = [];
    data.forEach((obj) => {
      let tempObj: DatasetInfo = { ...obj };
      let tempSplit = tempObj.title?.split(":");
      if (tempSplit && tempSplit.length > 2) {
        let newTitle = "";
        if (!showReader && showMeter) {
          newTitle += tempSplit[1] + ":";
        }
        if (showReader && !showMeter) {
          newTitle += tempSplit[0] + ":";
        }
        if (showReader && showMeter) {
          newTitle += tempSplit[0] + ":" + tempSplit[1] + ":";
        }

        for (let i = 2; i < tempSplit.length; i++) {
          newTitle += tempSplit[i];
        }

        tempObj.title = newTitle;
      }

      tempData.push(tempObj);
    });
    return tempData;
  };

  const onGlobalFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setFilters((prevFilters) => ({
      ...prevFilters,
      global: { ...prevFilters.global, value },
    }));
  };

  const tableHeaderTemplate = () => {
    return (
      <div className="flex flex-column gap-2">
        <div className="flex flex-row justify-content-between align-items-center">
          <div>Datasets</div>
          <div className="flex flex-row justify-content-end gap-3">
            <div className="flex-with-gap">
              <span>Show reader id</span>
              <Checkbox
                checked={showReader}
                onChange={(e) => setShowReader(e.checked as boolean)}
              />
            </div>
            <div className="flex-with-gap">
              <span>Show meter id</span>
              <Checkbox
                checked={showMeter}
                onChange={(e) => setShowMeter(e.checked as boolean)}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-content-between align-items-center gap-8">
          <div>Title</div>
          <InputText
            id="searchByTitle"
            type="search"
            placeholder="Search by title"
            className="w-12"
            value={(filters["global"] as DataTableFilterMetaData)?.value || ""}
            onChange={(e) => onGlobalFilterChange(e)}
          />
        </div>
      </div>
    );
  };

  return (
    <DataTable
      value={updateTitle(datasetsList)}
      dataKey="identifier"
      selectionMode="multiple"
      selection={selectedDatasets}
      metaKeySelection={false}
      onSelectionChange={handleDatasetsSelection}
      size="small"
      filterDisplay="menu"
      scrollable
      height={"calc(100vh - 52px)"}
      scrollHeight="calc(100vh - 52px)"
      filters={filters}
      onFilter={(e) => setFilters(e.filters)}
      className="w-4"
    >
      <Column field="title" header={tableHeaderTemplate} />
    </DataTable>
  );
};

export default AllDatasetsList;
